import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Storage } from '@ionic/storage'
import { UtilsProvider } from '../../providers/utils/utils';
import { ProductosProvider } from '../../providers/productos/productos';
import { AuthService } from '../../providers/auth-service';
import { ModalController, NavController, PopoverController, ToastController } from 'ionic-angular';
import { PushProvider } from '../../providers/push/push';
import { CompaniasProvider } from '../../providers/companias/companias';
import { NUBE_AWS } from '../../config/url.servicio';
import { CentroDeCostosProvider } from '../../providers/centro-de-costos/centro-de-costos';
import { ProductosCamposAdicionalesComponent } from '../productos-campos-adicionales/productos-campos-adicionales';
import { ProductosTransladosComponent } from '../productos-translados/productos-translados';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos';
import { ProductosCamposAdicionalesCambiarValorImpuestosComponent } from '../productos-campos-adicionales-cambiar-valor-impuestos/productos-campos-adicionales-cambiar-valor-impuestos';
import { Subject } from 'rxjs';
import { from } from 'rxjs/observable/from';
import { debounceTime, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { ModalSeleccionComponent } from '../modalseleccion/modalseleccion';
import { GruposProductosProvider } from '../../providers/gruposProductos/gruposProductos';
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados';
import { ImprimirGlobalComponent } from '../../pages/imprimir-global/imprimir-global';
import { Content } from 'ionic-angular';
import { CajaProvider } from '../../providers/caja/caja';
@Component({
  selector: 'productos-rapidos',
  templateUrl: 'productos-rapidos.html',
  providers:[
   UtilsProvider,ProductosProvider, AuthService,PushProvider,CompaniasProvider,
  ]
})
export class ProductosRapidosComponent implements OnInit  {

  tags = ['Ionic', 'Angular', 'TypeScript'];

  listaGruposProductos = []
  valoresCliente: string = 'Buscar Cliente';
  listaProductos = []
  listaClientes = [];
  filtrogruposProductosId
  // loader variable para guardar dialogos de alertas
  loader
  // saber si se esta filtrando
  nombreFiltroGrupo
  filtroGruposActivo: boolean = false
  // lista de productos que se van a comprar
  listaProductosSeleccionados = []
  valorTotalVenta = 0
  valorTotalProductos = 0
  valorTotalImpuestos = 0
  price = 0
  valorTotalDevolver = 0
  // saber si se esta realizando una venta
  realizandoUnaVenta: boolean = false
  clienteId = []
  clienteGenerico

  listaMuestra = []
  valormesa = 0
  datosAdicionales
  listaDenominaciones = []
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  timerVar;
  timerCodigoBarra;
  timerVal;
  public picture;
  public codigoBarra:any =""
  cantidadRealCodigoBarra:number = 0
  public formState: string = 'collapsed'
  public formStateDescripcion: string = 'collapsed'
  public formStatebool:boolean= false
  public formStateboolDescripcion:boolean= false
  codigoProducto
  nombreProducto
  valorVenta
  valorImpuesto: number = 0
  costo:number=0
  gruposProductosId = 0
  nombreGrupoProducto = ''
  productoId
  listaGrupos
  CheckCredito:boolean = false
  CheckImprimir:boolean = false
  datosCredito = []
  ventasDiarias = []
  valorImpuestosIndividual:number=0
  valorProductoIndividual :number=0
  allItems: any;
  buscar: any = "";
  manejaImpresoPorDefecto:boolean = true
  bluetooth:boolean = false
  listaABC = []
  imagenImprimir:boolean = false
  token:string
  element: HTMLElement;
  blue:string=''
  CheckPorcentajeServicio:boolean = false
  valorTotalServicio:number=0
  porcentajeServicioValor:string="N"
  porcentajeServicioValorPedidosSalon:string="N"
  cambiarFecha:boolean = false
  manejaCajaDinamica:boolean = false
  digitaCantidadEnVenta: boolean = false
  devolverVenta: boolean = false
  creaProductoRapidoDesdeCaja: boolean = false
  manejaCodigoDeBarras: boolean = false
  cantidadImpresionesEnCaja: string = "1"
  digitaDescripcion: boolean = false
  descripcionVenta: string = ""
  creaClienteDesdeCaja: boolean = false
  estadoFormCrearCliente: boolean = false
  visualizaDetalleReciboEnCaja: boolean = false
  formaPagoSeleccionada: string = 'O'

  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  direccionClienteRapido: string = ""
  cambiarPrecioEnLosProductos: boolean = false
  refactorizarPedidosSalon: boolean = false
  companiasId
  fechaVencimiento:Date
  manejaPlanDePagosEnCuentasPorCobrar: boolean = false
  guardarPlanDePagosEnCuentasPorCobrarSimulador: boolean = false
  gestionarSimuladorCuotasExtras: any | string = ''
  public productosId:any
  showCrearProducto: boolean = false;
  tipoproducto = 'P';
  tipoproductoTexto = 'Producto';
  data:any[] = []
  paginaActual: number = 1;
  buscarTexto: string = '';
  buscarTextoColor: string = '';
  item: string = '';
  showBuscarProducto: boolean = false;
  unidad = 'UND'
  unidadTexto = 'Unidad'
  tipoImpuesto = "I"
  tipoImpuestoTexto = "Impoconsumo"
  cantidadPorDefecto: number = 1;
  tallaSeleccionada: string = null;
  colorSeleccionado: string = null;
  cantidadSeleccionada: number = null;
  colorBusqueda: string = '';
  tallas = [];
  color = []
  combinacionesSeleccionadas = {};
  combinaciones = []; // Lista de colores filtrados
  colorExiste: boolean = false;
  coloresFiltrados: any[] = [];
  mostrarGrid:  boolean= false;
  mostrarGridColor: boolean = false;
  centroDeCostosId: string
  nombreCentroDeCosto:string = ''
  centrosDeCostos = []
  marca: string = ''
  linea: string = ''
  categoria: string = ''
  referencia: string = ''
  dataproductos:any[] = []
  productosSeleccionados = []
  nombreProductoValido: string = "";
  nombreCodigoDeBarraValido: string = "";
  private productoBusqueda$ = new Subject<string>();
  private codigoDeBarraBusqueda$ = new Subject<string>();
  visualizaEnCaja: boolean = true
  controlaEnInventario: boolean = true
  visualizaEnCajaTexto: string = 'SI'
  controlaEnInventarioTexto: string = 'SI'
  @ViewChild('fileInp') fileInput: ElementRef;
  imagen: string;
  typeImg: string;
  imagenProd: File;
  imagenUrl: string;
  existenciasActuales:number = 0
  controlaImpresorasEnRed: boolean = false;
  inputIP: string = ""
  isValidIP: boolean = true;
  nombreImpresora:string = ''
  ip:string = ''
  posicionScroll: number = 0;
  mostrarFlechaArriba: boolean = false;

  @ViewChild(Content) content: Content;
  clientes:any[]=[]
  clientesCopia:any[]=[]
  public page: number = 0;
  public search: string = '';
  totalPaginas: number = Infinity;
  cantidadPorPagina: number = 10;
  cargandoScroll:boolean = false;
  permitirSeleccion: boolean = true
  ultimoCodigoBarra: string = ""; // Para almacenar el último código leído
  ultimoTiempoEscaneo: number = 0;
  constructor(private storage: Storage,     public utils:UtilsProvider,
    public servicioProductos:ProductosProvider,  public auth: AuthService,
    public navCtrl: NavController, public push:PushProvider,
    public servicioCompania:CompaniasProvider,
    public serviciocentrodecosto: CentroDeCostosProvider,
    public toastControllers:ToastController,
    public modalControllers: ModalController,
    public servicioGrupos: ProductosPorGruposProvider,
    public servicioGruposImagen: GruposProductosProvider,
    public productosElaboradosProvider:ProductosElaboradosProvider,
    private popoverCtrl: PopoverController,
    private cd: ChangeDetectorRef,
    public servicio: CajaProvider,
  ) {
    this.imagenUrl = sessionStorage.getItem('imagenUrl') || '';
    this.buscarValoresProductos()
    this.traerDatosIp()
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
    .then((val)=>{

      if(val){
        this.nombreCompaniaHeader = val['nombreCompania']
        this.nombreCargoHeader = val['nombreCargo']
        this.companiasId = val['companiasId']
        this.push.buscarParametrosGenerales(this.companiasId).subscribe((data)=>{
            if(NUBE_AWS) {
              let valuesData = JSON.parse(data['_body']).data[0][0]
              this.bluetooth = valuesData.bluetooth === 'B' ? true : false
              this.manejaImpresoPorDefecto = valuesData.manejaImpresoPorDefecto == 0 ? false : true
              this.imagenImprimir = valuesData.imagen
              this.manejaCajaDinamica = valuesData.manejaCajaDinamica === 'N' ? false : true;
              this.digitaCantidadEnVenta = valuesData.digitaCantidadEnVenta === 'N' ? false : true;
              this.devolverVenta = valuesData.devolverVenta === 'N' ? false : true;
              this.creaProductoRapidoDesdeCaja = valuesData.creaProductoRapidoDesdeCaja === 'N' ? false : true;
              this.manejaCodigoDeBarras = valuesData.manejaCodigoDeBarras === 'N' ? false : true;
              this.CheckImprimir = valuesData.activoImprimir === 'N' ? false : true;
              this.cantidadImpresionesEnCaja = valuesData.cantidadImpresonesCaja.toString();
              this.digitaDescripcion = valuesData.digitaDescripcionEnCaja === 'N' ? false : true;
              this.creaClienteDesdeCaja = valuesData.creaClienteDesdeCaja === 'N' ? false : true;
              this.visualizaDetalleReciboEnCaja = valuesData.visualizaDetalleReciboEnCaja === 'N' ? false : true;
              this.manejaPlanDePagosEnCuentasPorCobrar = valuesData.manejaPlanDePagosEnCuentasPorCobrar === 'N' ? false : true;
              this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
              this.cambiarPrecioEnLosProductos = valuesData.cambiarPrecioEnLosProductos === 'N' ? false : true;
            } else {
              this.bluetooth = data[0][0].bluetooth === 'B' ? true : false
              this.manejaImpresoPorDefecto = data[0][0].manejaImpresoPorDefecto == 0 ? false : true
              this.imagenImprimir = data[0][0].imagen
              this.manejaCajaDinamica = data[0][0].manejaCajaDinamica === 'N' ? false : true;
              this.digitaCantidadEnVenta = data[0][0].digitaCantidadEnVenta === 'N' ? false : true;
              this.devolverVenta = data[0][0].devolverVenta === 'N' ? false : true;
              this.creaProductoRapidoDesdeCaja = data[0][0].creaProductoRapidoDesdeCaja === 'N' ? false : true;
              this.manejaCodigoDeBarras = data[0][0].manejaCodigoDeBarras === 'N' ? false : true;
              this.CheckImprimir = data[0][0].activoImprimir === 'N' ? false : true;
              this.cantidadImpresionesEnCaja = data[0][0].cantidadImpresonesCaja.toString();
              this.digitaDescripcion = data[0][0].digitaDescripcionEnCaja === 'N' ? false : true;
              this.creaClienteDesdeCaja = data[0][0].creaClienteDesdeCaja === 'N' ? false : true;
              this.visualizaDetalleReciboEnCaja = data[0][0].visualizaDetalleReciboEnCaja === 'N' ? false : true;
            }


            if(this.manejaImpresoPorDefecto){
                if(this.bluetooth){
                    this.manejaImpresoPorDefecto = false
                }
            }
        },(error)=>{
            console.log(error)
        })

      }
    })
  }


  async guardarProductoRapido(){
    let CodigoUuid = require('uuid/v4');
    let codigoUuid = CodigoUuid()
    codigoUuid = codigoUuid.substring(0,10)
    this.codigoProducto = codigoUuid

    if(this.codigoBarra == "" || this.codigoBarra == undefined) {
      this.codigoBarra = this.codigoProducto
    }
    if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" ){

    if(this.valorVenta == undefined || this.valorVenta == '') {
      if(this.valorImpuesto > 0) {
        this.utils.mensajeMuestro('Productos', 'El valor de la venta no puede ser 0 al ingresar un impuesto. Por favor, verifique los datos ingresados.', 'advertencia');
        return
      }
      this.valorVenta = 0
    }
    let imagenNueva = sessionStorage.getItem('imagenUrl') || 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png';

    this.storage.get('companiasId').then(async (val) => {
    let nombretabla = "productos";
    let queHago = "I"
    let datosProducto: any = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        valorVenta: this.valorVenta,
        existenciasMinimas:0,
        existenciasActuales: this.existenciasActuales,
        visualizaEnCaja: this.visualizaEnCaja,
        controlaEnInventario: this.controlaEnInventario,
        tipoImpuesto: this.tipoImpuesto,
        valorImpuesto: this. valorImpuesto,
        centroDeCostosId: this.centroDeCostosId,
        imagen:imagenNueva,
        codigoBarra:this.codigoBarra,
        companiasId:val,
        costo:this.costo,
        queHago: queHago,
        nombreTabla: "productos",
        name: "dataDynamicCrud",
        unidad: this.unidad,
        linea: this.linea,
        marca: this.marca,
        categoria: this.categoria,
        referencia: this.referencia,
        nombreImpresora: this.nombreImpresora
      }

      if(this.tipoproducto === "E") {
        nombretabla = "productosElaborados";
        datosProducto = {
          companiasId: val,
          valorCosto:this.costo,
          queHago: queHago,
          nombreTabla: "productosElaborados",
          name: "dataDynamicCrud",
          productosElaboradosId:  "0",
          codigoProductoElaborado: this.codigoProducto,
          nombreProductoElaborado: this.nombreProducto,
          imagen:imagenNueva,
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          estado: 0,
          prioridad: 0,
          codigoBarra:this.codigoBarra,
          unidad: this.unidad,
          centroDeCostosId: this.centroDeCostosId,
          linea: this.linea,
          marca: this.marca,
          categoria: this.categoria,
          referencia: this.referencia,
          nombreImpresora: this.nombreImpresora
        }
    }
    if(this.combinaciones.length === 0) {
      let companiasId = val
      let reponseExiste = await this.servicioProductos.buscarProductosExistente(companiasId,this.nombreProducto)
      let reponseExisteValidar = JSON.parse(reponseExiste['_body'])
      if(reponseExisteValidar && reponseExisteValidar.data && reponseExisteValidar.data[0] && reponseExisteValidar.data[0][0]
        && reponseExisteValidar.data[0][0].existe === '1'
      ) {
          let response = `El código del producto que desea ingresar ya existe en la base de datos. ¿ Desea crear este producto ?'
          `
          this.utils.mensajeConfirmacionDos('Guardar producto',response,'question','Si','No')
          .then(async (guardar: boolean) => {
            if (guardar) {
              this.servicioProductos.guardarProducto(datosProducto,nombretabla)
              .subscribe(
                async (res:any) => {

                      let tipo = this.tipoproducto === "E" ? "E" : "P"
                      let codigoProducto = this.codigoProducto
                      let gruposProductosId = this.gruposProductosId

                      if(gruposProductosId > 0) {
                        let datos = await this.servicioProductos.gestionarProductosPorGrupos(val,codigoProducto,tipo,gruposProductosId,queHago)
                        let response = datos.json()
                        if(response && response.data && response.data[0]){
                          this.utils.mensajeMuestroConCerrado('productos',"El producto se guardo con exito y se asocio el producto por grupo..","success",true)
                        }

                      } else {
                        this.utils.mensajeMuestroConCerrado('productos',"Producto guardado..","success",true)
                      }


                  this.limpiarProducto()
                  this.limpiarProductoRapido()
                  this.buscarValoresProductos()
                },
                err => {
                    this.utils.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
                    this.limpiarProductoRapido()
                }
              )
              } else {
              this.utils.mensajeMuestro('Producto',"el producto no se guardo.","warning")
              this.limpiarProducto()
              this.limpiarProductoRapido()
              this.buscarValoresProductos()
            }
           })



      } else {
          this.servicioProductos.guardarProducto(datosProducto,nombretabla)
          .subscribe(
            async (res:any) => {
                  let tipo = this.tipoproducto === "E" ? "E" : "P"
                  let codigoProducto = this.codigoProducto
                  let gruposProductosId = this.gruposProductosId

                  if(gruposProductosId > 0) {
                    let datos = await this.servicioProductos.gestionarProductosPorGrupos(val,codigoProducto,tipo,gruposProductosId,queHago)
                    let response = datos.json()
                    if(response && response.data && response.data[0]){
                      this.utils.mensajeMuestroConCerrado('productos',"El producto se guardo con exito y se asocio el producto por grupo..","success",true)
                    }
                } else {
                   this.utils.mensajeMuestroConCerrado('productos',"Producto guardado..","success",true)
                }


              this.limpiarProducto()
              this.limpiarProductoRapido()
              this.buscarValoresProductos()
            },
            err => {
                this.utils.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
                this.limpiarProductoRapido()
            }
          )
      }


    } else {
      this.guardarProductoConCombinaciones(datosProducto,nombretabla)
    }


    })
}else{
    this.utils.mensajeMuestro('productos',"No se pudo guardar el producto existen campos obligatorios","advertencia")
    this.limpiarProductoRapido()
}
}

async guardarProductoConCombinaciones(datosProducto:any, nombreProducto:any) {
  try {
    for (const combinacion of this.combinaciones) {
      if (combinacion.cantidad > 0) {
        let CodigoUuid = require('uuid/v4');
        let codigoUuid = CodigoUuid()
        codigoUuid = codigoUuid.substring(0,10)
        this.codigoProducto = codigoUuid
        // Actualizamos los datosProducto con las propiedades de la combinación
        let agregadoNombre = combinacion.talla != null ? ' T: ' + combinacion.talla : ''
        agregadoNombre+= combinacion.color != null ? ' C: ' + combinacion.color : ''
        let datosProductoModificado = {
          ...datosProducto, // Mantenemos los valores originales de datosProducto
          talla: combinacion.talla == null ? '' : combinacion.talla,
          color: combinacion.color == null ? '' : combinacion.color,
          existenciasActuales: combinacion.cantidad,
          nombreProducto:datosProducto.nombreProducto + ' ' + agregadoNombre
        };
        if(nombreProducto !== 'productos') {
          datosProductoModificado.codigoProductoElaborado = this.codigoProducto
        } else {
          datosProductoModificado.codigoProducto = this.codigoProducto
        }
        // Guardamos el producto con los nuevos datos
        await this.servicioProductos.guardarProductoAsync(datosProductoModificado, nombreProducto);

        let tipo = this.tipoproducto === "E" ? "E" : "P"
        let codigoProducto = this.codigoProducto
        let gruposProductosId = this.gruposProductosId

        let companiasId = await localStorage.getItem('companiasId')
        let datos = await this.servicioProductos.gestionarProductosPorGrupos(companiasId,codigoProducto,tipo,gruposProductosId,"I")

        let response = datos.json()
        if(response && response.data && response.data[0]){
          this.utils.mensajeMuestro('productos por grupo',"productos por grupo guardado..","success")
        }
      }
    }

    // Mostrar mensaje después de guardar todos los registros
    this.utils.mensajeMuestro('Éxito', 'Todos los productos se han guardado correctamente.', '');
    this.limpiarProductoRapido()
  } catch (error) {
    console.error('Error al guardar productos:', error);
    this.utils.mensajeMuestro('Error', 'Ocurrió un error al guardar los productos.', '');
  }
}


limpiarProductoRapido(){
  this.valorImpuesto = 0
  this.codigoBarra =""
  this.nombreProducto = ""
  this.codigoProducto = ""
  this.valorVenta = 0
  this.costo = 0
  this.formState = 'collapsed'
  this.formStatebool = false
  this.productoId = ""
  this.cantidadRealCodigoBarra = 0
  this.unidad = "UND"
  this.unidadTexto = "Unidad"
  this.tipoImpuesto = "I"
  this.tipoImpuestoTexto = "Impoconsumo"
  this.combinaciones = []
  this.linea = ""
  this.marca = ""
  this.categoria  = ""
  this.referencia  = ""
  this.productosId = 0
  this.tipoproducto = ""
  this.productosSeleccionados = []
  this.fileInput.nativeElement.value = '';
  this.imagenProd = null;
  this.imagen = ''
  this.eliminarImagen()
  this.existenciasActuales = 0
  this.nombreCodigoDeBarraValido = "";
  this.nombreProductoValido = "";
}
limpiarProducto(){
  this.valorImpuesto = 0
  this.codigoBarra =""
  this.nombreProducto = ""
  this.codigoProducto = ""
  this.valorVenta = 0
  this.costo = 0
  this.formState = 'collapsed'
  this.formStatebool = false
  this.productoId = ""
  this.cantidadRealCodigoBarra = 0
  this.unidad = "UND"
  this.unidadTexto = "Unidad"
  this.tipoImpuesto = "I"
  this.tipoImpuestoTexto = "Impoconsumo"
  this.linea = ""
  this.marca = ""
  this.categoria  = ""
  this.referencia  = ""
  this.productosId = 0
  this.tipoproducto = ""
  this.productosSeleccionados = []
  this.fileInput.nativeElement.value = '';
  this.imagenProd = null;
  this.imagen = ''
  this.eliminarImagen()
  this.existenciasActuales = 0
  this.nombreCodigoDeBarraValido = "";
  this.nombreProductoValido = "";
}
cerrarSession(){
  this.auth.logout()
  this.navCtrl.setRoot('LoginPage');
}
agregarCombinacion() {
  this.productosSeleccionados = []
  this.consultarProductosCoincidenOtrasCompanias(this.tallaSeleccionada,this.colorSeleccionado)
  const nuevaCombinacion = {
    talla: this.tallaSeleccionada,
    color: this.colorSeleccionado,
    cantidad: this.cantidadSeleccionada ? this.cantidadSeleccionada : this.cantidadPorDefecto
  };

  this.combinaciones.push(nuevaCombinacion);

  // Limpiar selección después de agregar
  this.tallaSeleccionada = null;
  this.colorSeleccionado = null;
  this.cantidadSeleccionada = null;
}

eliminarCombinacion(combinacion) {
  const index = this.combinaciones.indexOf(combinacion);
  if (index > -1) {
    this.combinaciones.splice(index, 1);
  }
}

// Método para mostrar una alerta de confirmación
mostrarAlerta(titulo: string, mensaje: string) {
  this.utils.mostrarMensaje(titulo,mensaje)
}

// Método para seleccionar un color de las sugerencias
seleccionarColor(color) {
  this.colorBusqueda = color.color;  // Actualizar la búsqueda con el color seleccionado
  this.coloresFiltrados = [];        // Limpiar las sugerencias
  this.colorExiste = true;           // Marcar como que el color ya existe
}

buscarSearchbar(event) {
  if(event.value == '') {
    this.mostrarGrid = true
    return
  }
  let buscarTexto = event.value;

  const tallasFiltradas = this.tallas.filter(item =>
    item.talla.toLowerCase().includes(buscarTexto.toLowerCase())
  );

  // Si no hay tallas coincidentes, mostrar el botón para agregar una nueva talla
  if (tallasFiltradas.length === 0) {
    this.mostrarGrid = false;  // Mostrar el botón de agregar
  } else {
    this.mostrarGrid = true; // Ocultar el botón de agregar
  }
  this.buscarTexto = buscarTexto
}


buscarSearchbarColor(event) {
  if(event.value == '') {
    this.mostrarGridColor = true
    return
  }
  let buscarTextoColor = event.value;

  const colorFiltradas = this.color.filter(item =>
    item.color.toLowerCase().includes(buscarTextoColor.toLowerCase())
  );

  // Si no hay color coincidentes, mostrar el botón para agregar un nuevo color
  if (colorFiltradas.length === 0) {
    this.mostrarGridColor = false;  // Mostrar el botón de agregar
  } else {
    this.mostrarGridColor = true; // Ocultar el botón de agregar
  }
  this.buscarTextoColor = buscarTextoColor
}

ionViewDidLoad() {
  this.paginaActual = 1;
  this.buscarTallas()
  this.buscarColor()
  this.buscarCentrosDeCostosTodos()
  this.buscarValoresProductos()
  this.cargarProductosPaginados()
  this.traerDatosIp()
}

async traerDatosIp() {
  let companiasId = await localStorage.getItem('companiasId')
  this.productosElaboradosProvider.buscarParametroGeneralIp(companiasId)
  .subscribe(
    res => {
      let responseControlaImpresora = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
      if(responseControlaImpresora.length > 0) {
        this.controlaImpresorasEnRed  = responseControlaImpresora[0].controlaImpresorasEnRed == 'S' ? true : false;
        this.ip = responseControlaImpresora[0].ip;
      }
    },
    err => {
      console.log('No se sabe si contrala impresara en red, intente luego')
    }
  )
}

async buscarColor() {
  let companiaId = await localStorage.getItem('companiasId')
  let data = await this.servicioProductos.buscarColores(companiaId);
  let response = data.json()
  if(response && response.data && response.data[0]){
    this.color = response.data[0]
  }
}

async buscarTallas() {
  let companiaId = await localStorage.getItem('companiasId')
  let data = await this.servicioProductos.buscarTallas(companiaId);
  let response = data.json()
  if(response && response.data && response.data[0]){
    this.tallas = response.data[0]
  }
}


devolverValor(item) {
  this.tallaSeleccionada = item.talla
  this.buscarTexto = "-"
  this.mostrarGrid = false
}

devolverValorColor(item) {
  this.colorSeleccionado = item.color
  this.buscarTextoColor = "-"
  this.mostrarGridColor = false
}

selectInputContentTallas(event: any) {
  const inputElement = event.target;
  if(inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}

selectInputContentColor(event: any) {
  const inputElement = event.target;
  if(inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}

toggleForm(){
  this.formState = (this.formState == 'collapsed') ? 'expanded' : 'collapsed'
  this.formStatebool = !this.formStatebool
}
label(){
  return (this.formState == 'collapsed') ? 'Campos adicionales' : 'Ocultar campos adicionales'
}
icon(){
return (this.formState == 'collapsed') ? 'arrow-dropright-circle' : 'arrow-dropleft-circle'
}

buscarCentrosDeCostosTodos(){
  this.storage.get('companiasId').then((val) => {
  this.centrosDeCostos = []
  this.serviciocentrodecosto.buscar('',val)
  .subscribe(
    (centrosCostos: any) => {
      let data : any = centrosCostos;
      this.centrosDeCostos = data
      if (this.centrosDeCostos.length > 0) {
        this.centroDeCostosId = this.centrosDeCostos[0].value;
        this.nombreCentroDeCosto = this.centrosDeCostos[0].display;
      }
    },

    err => {
      this.utils.mensajeMuestro('Productos','No se encontraron Centros de Costos.','')
  });
}
)}

async agregarColor(color:any) {
  let companiaId = await localStorage.getItem('companiasId')
  this.colorSeleccionado = color
  let data = await this.servicioProductos.guardarColor(companiaId,color);
  let response = data.json()
  if(response && response.data && response.data[0]){
    this.color = response.data[0]
  }
  this.mensajeToast('Color gestionada con exito...')
  this.colorSeleccionado = ''
  this.buscarColor()
}

async agregarTalla(talla:any) {
  let companiaId = await localStorage.getItem('companiasId')
  this.tallaSeleccionada = talla
  let data = await this.servicioProductos.guardarTalla(companiaId,talla);
  let response = data.json()
  if(response && response.data && response.data[0]){
    this.tallas = response.data[0]
  }
  this.mensajeToast('Talla gestionada con exito...')
  this.tallaSeleccionada = ''
  this.buscarTallas()
}
mensajeToast(mensaje: string) {
  let item =    {
      "duration": 1000,
      "position": "buttom"
    }
    item["message"] = mensaje;
  let toast = this.toastControllers.create(item);
  toast.present();
}

async buscarValoresProductos() {
  let companiaId = await this.storage.get('companiasId')
  this.servicioGrupos.buscarGruposCompaniasId(companiaId)
  .subscribe(
    res => {
      this.listaGrupos = !NUBE_AWS ? res : JSON.parse(res['_body']).data[0]
      if (this.listaGrupos.length > 0) {
        this.gruposProductosId = this.listaGrupos[0].gruposProductosId;
        this.nombreGrupoProducto = this.listaGrupos[0].nombreGrupoProducto;
      }
    },
    err => {
    }
  )

this.servicioProductos.buscarTodosLosProductosPaginados(companiaId)
.subscribe(async (data: any)=>{
  let productos: any = data;
  this.dataproductos = productos.reverse();
},(error)=> {console.log(error)})
this.traerDatosIp()
}


selectInputContent(event: any) {
  const inputElement = event.target;
  if(inputElement && inputElement.value) {
    inputElement.setSelectionRange(0, inputElement.value.length);
  }
}

buscarProductos(event) {
  this.buscarTexto = event.value;
}

devolverValorProductos(item) {
  setTimeout(() => {
    this.content.scrollToTop(300); // 300ms para desplazamiento suave
  }, 50);
  let data  = item;
  this.productosId = Number(data.productosId)
  this.tipoproducto = data.tipoProducto
  this.nombreProducto = data.display
  this.buscarCamposBaseProducto(this.productosId, this.tipoproducto)
}

camposAdicionales() {
  if(this.productosId == 0 || this.productosId == undefined) {
    this.utils.mensajeMuestro('Productos','Para gestionar campos adicionales debe estar actualizando un producto','warning')
    return
  }
  let modal = this.modalControllers.create(ProductosCamposAdicionalesComponent, { productosId: this.productosId, tipo: this.tipoproducto , nombreProducto:this.nombreProducto}, {
      cssClass: 'fullscreen-modal',
      enableBackdropDismiss: true
  })
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {}
    this.productosId = 0
    this.tipoproducto = ''
    this.nombreProducto = ''
  })
  }
  actualizarValorProducto(item) {
    const modal = this.modalControllers.create(ProductosTransladosComponent, { producto: item });

    modal.onDidDismiss((data) => {
      if (data) {
        console.log("Datos actualizados:", data);
        // Aquí puedes actualizar la información del producto en la lista
        // this.actualizarProductoEnLista(data);

      }
    });

    modal.present();
  }

  async consultarProductosCoincidenOtrasCompanias(talla:any,color:any) {
    let companiasId = await this.storage.get('companiasId')
    let data = await this.servicioProductos.consultarProductosCoincidenOtrasCompanias(companiasId,this.marca,this.linea,this.referencia,talla,color,this.nombreProducto,this.categoria)
    let response = data.json()
    if(response && response.data && response.data[0]){
      this.productosSeleccionados = response.data[0]
    }
  }

  actualizar(){
    let CodigoUuid = require('uuid/v4');
    let codigoUuid = CodigoUuid()
    codigoUuid = codigoUuid.substring(0,10)
    this.codigoProducto = codigoUuid

    if(this.codigoBarra == "" || this.codigoBarra == undefined) {
      this.codigoBarra = this.codigoProducto
    }
    if(this.codigoProducto !=="" && this.nombreProducto !== "" && this.codigoBarra !== "" && this.valorVenta !== 0){

    let imagenNueva = sessionStorage.getItem('imagenUrl') || 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png';
    this.storage.get('companiasId').then((val) => {
    let nombretabla = "productos";
    let datosProducto: any = {
        codigoProducto: this.codigoProducto,
        nombreProducto: this.nombreProducto,
        valorVenta: this.valorVenta,
        existenciasMinimas:0,
        existenciasActuales: this.existenciasActuales,
        visualizaEnCaja: this.visualizaEnCaja,
        controlaEnInventario: this.controlaEnInventario,
        tipoImpuesto: this.tipoImpuesto,
        valorImpuesto: this. valorImpuesto,
        centroDeCostosId: this.centroDeCostosId,
        imagen:imagenNueva,
        codigoBarra:this.codigoBarra,
        companiasId:val,
        costo:this.costo,
        queHago: "A",
        nombreTabla: "productos",
        name: "dataDynamicCrud",
        unidad: this.unidad== null ? '' : this.unidad ,
        linea: this.linea== null ? '' : this.linea ,
        marca: this.marca == null ? '' : this.marca ,
        categoria: this.categoria == null ? '' : this.categoria ,
        referencia: this.referencia == null ? '' : this.referencia ,
        productosId:this.productosId,
        nombreImpresora:this.nombreImpresora
      }

      if(this.tipoproducto === "E") {
        nombretabla = "productosElaborados";
        datosProducto = {
          companiasId: val,
          valorCosto:this.costo,
          queHago: "A",
          nombreTabla: "productosElaborados",
          name: "dataDynamicCrud",
          productosElaboradosId: this.productosId,
          codigoProductoElaborado: this.codigoProducto,
          nombreProductoElaborado: this.nombreProducto,
          imagen:imagenNueva,
          valorVenta: this.valorVenta,
          tipoImpuesto: this.tipoImpuesto,
          valorImpuesto: this.valorImpuesto,
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          estado: 0,
          prioridad: 0,
          codigoBarra:this.codigoBarra,
          centroDeCostosId: this.centroDeCostosId,
          unidad: this.unidad== null ? '' : this.unidad ,
          linea: this.linea== null ? '' : this.linea ,
          marca: this.marca == null ? '' : this.marca ,
          categoria: this.categoria == null ? '' : this.categoria ,
          referencia: this.referencia == null ? '' : this.referencia,
          nombreImpresora:this.nombreImpresora
        }
    }
    if(this.combinaciones.length === 0) {
      this.servicioProductos.guardarProducto(datosProducto,nombretabla)
      .subscribe(
        (res:any) => {
          let responseJson = JSON.parse(res['_body'])
          let response = ''
          this.utils.mensajeMuestroConCerrado('productos',"El producto se actualizado con exito..","success",true)

          this.limpiarProducto()
          this.limpiarProductoRapido()
          this.paginaActual = 1;
          this.buscarTallas()
          this.buscarColor()
          this.buscarCentrosDeCostosTodos()
          this.buscarValoresProductos()

        },
        err => {
            this.utils.mensajeMuestro('productos',"No se pudo guardar el producto intente luego","advertencia")
            this.limpiarProductoRapido()
            this.paginaActual = 1;
            this.buscarTallas()
            this.buscarColor()
            this.buscarCentrosDeCostosTodos()
            this.buscarValoresProductos()
        }
      )
    } else {
      this.guardarProductoConCombinaciones(datosProducto,nombretabla)
      this.paginaActual = 1;
      this.buscarTallas()
      this.buscarColor()
      this.buscarCentrosDeCostosTodos()
      this.buscarValoresProductos()
    }


    })
}else{
    this.utils.mensajeMuestro('productos',"No se pudo guardar el producto existen campos obligatorios","advertencia")
    this.limpiarProductoRapido()
}
}

async buscarCamposBaseProducto(productosId:any, tipo:any) {
  let companiasId = await this.storage.get('companiasId')
  let data = await this.servicioProductos.buscarCamposBaseProducto(companiasId,productosId,tipo)
  let response = data.json()
  if(response && response.data && response.data[0]){
    let productosBase = response.data[0]
    this.llenarCamposBase(productosBase)
  }
}

llenarCamposBase(data:any) {
  this.valorVenta = data[0].valorVenta,
  this.tipoImpuesto = data[0].tipoImpuesto,
  this.valorImpuesto = data[0].valorImpuesto,
  this.codigoBarra = data[0].codigoBarra
  this.unidad = data[0].unidad
  this.centroDeCostosId = data[0].centroDeCostosId
  this.linea = data[0].linea
  this.marca = data[0].marca
  this.categoria = data[0].categoria
  this.referencia = data[0].referencia
  this.nombreProducto = data[0].nombreProducto
  this.codigoProducto = data[0].codigoProducto
  this.productosId = data[0].productosId
  this.centroDeCostosId = data[0].centroDeCostosId
  this.costo = data[0].costo
  if (data[0].imagen) {
    this.imagen = data[0].imagen; // Cargar la imagen en la vista
    sessionStorage.setItem('imagenUrl', this.imagen); // Guardarla en sessionStorage
  } else {
    this.imagen = 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png';
  }
  this.existenciasActuales = data[0].existenciasActuales
  let tipoProducto = data[0].tipoProducto
  this.toggleTipoProductoAsignarValorReal(tipoProducto)
  this.toggleTipoImpuestoAsignarValorReal(this.tipoImpuesto)
}

buscarporCompania(item:any){

  let idgrupo = this.buscarUuidGrupos()
  let gruposProductosId = idgrupo && idgrupo.length>0 ? idgrupo[0].gruposProductosId: item
  this.gruposProductosId = Number(gruposProductosId)
}


buscarUuidGrupos(){

  let data = []
  let valorComparar = Number(this.gruposProductosId)
  for(let k=0;k< this.listaGrupos.length;k++){
    if(k === valorComparar){

      data.push({
        gruposProductosId : this.listaGrupos[k].gruposProductosId
      })
      k = this.listaGrupos.length + 1
    }
  }

  return data

}

actualizarImpuestos() {
  if(this.productosId == 0 || this.productosId == undefined) {
    this.utils.mensajeMuestro('Productos','Para actualizar impuestos debe estar actualizando un producto','warning')
    return
  }
  let modal = this.modalControllers.create(ProductosCamposAdicionalesCambiarValorImpuestosComponent, { productosId: this.productosId, tipo: 'P' , nombreProducto:this.nombreProducto}, {
      cssClass: 'fullscreen-modal',
      enableBackdropDismiss: true
  })
  modal.present();

  modal.onDidDismiss(data => {
    if (data) {
    }
  })
  }

  validarProducto(nombreProducto: string) {
    this.productoBusqueda$.next(nombreProducto); // Envía el nuevo valor para aplicar debounce
  }

  buscarGruposModal() {
    if(this.listaGrupos.length>0) {
        // Intervenir la lista para incluir los campos 'nombre' y 'codigo' de manera uniforme
      const listaModificada = this.listaGrupos.map((item) => ({
        ...item,
        nombre: item.nombreGrupoProducto || item.nombre, // Usamos nombreGrupoProducto si está disponible
        codigo: item.codigoGrupoProducto || item.codigo // Usamos codigoGrupoProducto si está disponible
      }));

      this.showModalGruposProductos(listaModificada)
    }
  }

  showModalGruposProductos(lista:any) {
    const modal = this.modalControllers.create(ModalSeleccionComponent, { lista:lista });
    modal.present();

    modal.onDidDismiss((selected) => {
      if (selected) {
        this.gruposProductosId = selected.gruposProductosId
        this.nombreGrupoProducto = selected.nombreGrupoProducto
        // Aquí puedes manejar  seleccionado, por ejemplo:
        console.log('seleccionado: ', selected);
        // Puedes almacenar el grupo seleccionado en alguna variable o procesarlo.
      }
    });
  }

  toggleTipoProducto() {
    this.tipoproducto = this.tipoproducto === 'E' ? 'P' : 'E';
    if(this.tipoproducto === 'P') {
      this.tipoproductoTexto = 'Producto'
    } else {
      this.tipoproductoTexto = 'Producto elaborado'
    }
  }

  toggleTipoImpuesto() {
    this.tipoImpuesto = this.tipoImpuesto === 'I' ? 'V' : 'I';
    if(this.tipoImpuesto === 'I') {
      this.tipoImpuestoTexto = 'Impoconsumo'
    } else {
      this.tipoImpuestoTexto = 'Iva'
    }
  }


  buscarCentrosDeCostoModal() {
    if(this.centrosDeCostos.length>0) {
        // Intervenir la lista para incluir los campos 'nombre' y 'codigo' de manera uniforme
      const listaModificada = this.centrosDeCostos.map((item) => ({
        ...item,
        nombre: item.display || item.nombre,
        codigo: undefined
      }));

      this.showModalCentrosDeCosto(listaModificada)
    }
  }

  showModalCentrosDeCosto(lista:any) {
    const modal = this.modalControllers.create(ModalSeleccionComponent, { lista:lista });
    modal.present();

    modal.onDidDismiss((selected) => {
      if (selected) {
        this.centroDeCostosId = selected.value
        this.nombreCentroDeCosto = selected.display
        console.log('seleccionado: ', selected);
      }
    });
  }

  buscarUnidadModal() {
    let listaUnidades = [
      {
        "nombre": "Unidad",
        "codigo": "UND"
      },
      {
        "nombre": "Kilogramo",
        "codigo": "KG"
      },
      {
        "nombre": "Paquete",
        "codigo": "PAQ"
      }
    ]

      // unidad
      const listaModificada = listaUnidades.map((item) => ({
        ...item,
        nombre: item.nombre || item.nombre,
        codigo: item.codigo || item.codigo
      }));

      this.showModalUnidades(listaModificada)
    }

    showModalUnidades(lista:any) {
      const modal = this.modalControllers.create(ModalSeleccionComponent, { lista:lista });
      modal.present();

      modal.onDidDismiss((selected) => {
        if (selected) {
          this.unidad = selected.codigo
          this.unidadTexto = selected.nombre
          console.log('seleccionado: ', selected);
        }
      });
    }
    async ngOnInit() {
      this.updateFabPosition();
       window.addEventListener('scroll', this.updateFabPosition);
      let companiasId = await localStorage.getItem('companiasId')
      this.productoBusqueda$
        .pipe(
          debounceTime(3000), // Espera 3 segundos después de la última entrada
          filter((nombreProducto) => !!nombreProducto),
          distinctUntilChanged(),
          switchMap((nombreProducto) =>
            from(this.servicioProductos.buscarProductosExistente(companiasId, nombreProducto))
          )
        )
        .subscribe((responseExiste) => {
          let responseExisteValidar = JSON.parse(responseExiste['_body']);

          if (
            responseExisteValidar && responseExisteValidar.data &&
            responseExisteValidar.data[0] && responseExisteValidar.data[0][0] &&
            responseExisteValidar.data[0][0].existe === '1'
          ) {
            this.nombreProductoValido = "El producto ya existe en la base de datos. Si desea continuar ingresando el mismo producto, complete los demás campos. Verifique la información antes de proceder.";
          } else {
            this.nombreProductoValido = "";
          }
        });

        this.codigoDeBarraBusqueda$
        .pipe(
          debounceTime(3000), // Espera 3 segundos después de la última entrada
          filter((codigoDeBarra) => !!codigoDeBarra),
          distinctUntilChanged(),
          switchMap((codigoDeBarra) =>
            from(this.servicioCompania.buscarCodigoBarraAsync(companiasId, codigoDeBarra))
          )
        )
        .subscribe((responseExiste) => {
          let responseExisteValidar = JSON.parse(responseExiste['_body']);

          if (
            responseExisteValidar && responseExisteValidar.data &&
            responseExisteValidar.data[0] && responseExisteValidar.data[0][0] &&
            responseExisteValidar.data[0][0].companiasId
          ) {
            let response = `El código de barras ya existe en la base de datos. ¿ Desea actualizar este producto: ${responseExisteValidar.data[0][0].nombreProducto}  ?
            `
            this.utils.mensajeConfirmacionDos('Guardar producto',response,'question','Si','No')
            .then(async (actualizar: boolean) => {
              if (actualizar) {
                this.nombreCodigoDeBarraValido = "El código de barras ya existe en la base de datos. Verifique la información antes de proceder.";
                this.devolverValorCodigoDeBarras(responseExisteValidar.data[0][0])
              } else {
                this.nombreCodigoDeBarraValido = "";
                this.codigoBarra = ""
              }
            }, (error)=> {
              console.log(error)
              setTimeout(() => {
                this.nombreCodigoDeBarraValido = "";
              }, (3000));
            })

            setTimeout(() => {
              this.nombreCodigoDeBarraValido = "";
            }, (3000));
          } else {
            this.nombreCodigoDeBarraValido = "";
          }
        });


    }

    validarSiExisteCodigoDeBarra(codigoDeBarra: string) {
      this.codigoDeBarraBusqueda$.next(codigoDeBarra); // Envía el nuevo valor para aplicar debounce
    }

    devolverValorCodigoDeBarras(item) {
      let data  = item;
      this.productosId = Number(data.productosId)
      this.tipoproducto = data.tipoproducto
      this.nombreProducto = data.nombreProducto
      this.buscarCamposBaseProducto(this.productosId, this.tipoproducto)
    }


    toggleVisualizaEnCaja() {
      this.visualizaEnCaja = this.visualizaEnCaja ? false : true;
      if(this.visualizaEnCaja) {
        this.visualizaEnCajaTexto = 'SI'
      } else {
        this.visualizaEnCajaTexto = 'NO'
      }
    }

    toggleControlaInventario() {
      this.controlaEnInventario = this.controlaEnInventario === true ? false : true;
      if(this.controlaEnInventario) {
        this.controlaEnInventarioTexto = 'SI'
      } else {
        this.controlaEnInventarioTexto = 'NO'
      }
    }


  onClick() {
    this.fileInput.nativeElement.click();
  }
  fileUpload(event) {
    if (!event.target.files || event.target.files.length === 0) {
      console.log('No se seleccionó ninguna imagen.');
      return;
    }

    this.imagenProd = event.target.files[0];
    this.typeImg = this.imagenProd.type;

    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.imagen = e.target.result; // Actualiza la vista con la imagen seleccionada
    };

    reader.readAsDataURL(this.imagenProd);

    // Después de cargar la imagen, llamamos a `subirImagen()`
    this.subirImagen();
  }

  subirImagen() {
    if (!this.imagenProd) {
      console.log('Error: No se ha seleccionado una imagen.');
      return;
    }

    const data = new FormData();
    data.append('file', this.imagenProd);

    this.servicioGruposImagen.guardarImagenUnica(data).subscribe(
      (res: any) => {
        if (res && res.link) {
          this.imagenUrl = res.link;
          sessionStorage.setItem('imagenUrl', this.imagenUrl);
          console.log('Imagen guardada en sesión:', this.imagenUrl);
        }
      },
      (error) => {
        console.error('Error al subir la imagen:', error);
      }
    );
  }

  eliminarImagen() {
    sessionStorage.removeItem('imagenUrl');
    this.imagenUrl = '';
    console.log('Imagen eliminada de la sesión.');
  }

  ionViewWillEnter() {
    this.imagen = sessionStorage.getItem('imagenUrl') || 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png';
  }
  validateIP() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    this.isValidIP = ipPattern.test(this.nombreImpresora);
    if(!this.isValidIP) {
      this.utils.mensajeMuestro('Productos','Ip no valida','warning')
      this.nombreImpresora = ''
    }
  }

  cargarDatosIp() {
    this.productosElaboradosProvider.buscarParametroGeneralIp(this.companiasId)
    .subscribe(
      res => {
        let responseControlaImpresora = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        if(responseControlaImpresora.length > 0) {
          this.controlaImpresorasEnRed  = responseControlaImpresora[0].controlaImpresorasEnRed == 'S' ? true : false;
          this.ip = responseControlaImpresora[0].ip;
        }
      },
      err => {
        this.utils.mensajeMuestro('Productos','No se sabe si contrala impresara en red, intente luego','warning')
        this.controlaImpresorasEnRed = false
      }
    )
  }

  imprimirGlobal(devolverNombreImpresora:string) {
    let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: '',
      queHago:devolverNombreImpresora,
      cantidadImpresionesEnCaja: '1',
      ip:this.ip
    });
    popover.present({
      ev: ''
    });
    popover.onDidDismiss((data) => {
      if (data) {
        this.nombreImpresora = data
      }
    });
  }


  eliminar(item:any) {
    this.utils.mensajeConfirmacionDos('Productos',`¿Está Seguro de borrar el producto: ${item.nombreProducto} ?`,'question','Si','No')
     .then((loQuiereBorrar: boolean) => {
      if (loQuiereBorrar) {
        this.search =""
        this.allItems = []
        let tipo = item.tipoProducto
        this.servicioProductos.eliminarCualquierProducto(item,tipo)
        .subscribe(
          res => {
            this.utils.mensajeMuestroConCerrado('Productos','Eliminado Exitosamente!','success', true)
            this.limpiarProducto()
            this.limpiarProductoRapido()
            this.buscarValoresProductos()
            this.eliminarImagen()
          },
          err => this.utils.mensajeMuestroConCerrado('Productos','No se eliminó el producto','error', true)
          )

      }
      else {
        this.utils.mensajeMuestroConCerrado('Productos','No se eliminó el registro','warning',true)
      }
    })
  }



  ngOnDestroy() {
    window.removeEventListener('scroll', this.updateFabPosition);
  }

  updateFabPosition = () => {
    const grid = document.querySelector('.grid-container-productos') as HTMLElement;
    const fab = document.getElementById('scrollButton') as HTMLElement;

    if (grid && fab) {
      const rect = grid.getBoundingClientRect();
      const middleY = rect.top + rect.height / 2;

      fab.style.top = `${middleY}px`;
    }
  }

  // ✅ Mantiene la funcionalidad actual de volver arriba desde el ion-header
  scrollToTop() {
    this.content.scrollToTop(300);
  }

  // ✅ Cuando el usuario selecciona un producto, también vuelve arriba
  seleccionarProducto(item,event:Event,infiniteScroll) {
    if (event) {
      event.stopPropagation();  // Evita que el evento se propague
    }
        // Aquí podrías completar el scroll si es necesario
        if (infiniteScroll) {
          infiniteScroll.complete();
          infiniteScroll.enable(false);  // Desactiva el scroll
      }
    this.devolverValorProductos(item); // Función original
    this.scrollToTop();
  }


  async cargarProductosPaginados(infiniteScroll?) {
    if (this.cargandoScroll) return; // Evita múltiples llamadas concurrentes
    this.cargandoScroll = true; // Marca que está en proceso de carga

    let companiasId = await localStorage.getItem('companiasId');

    if (this.paginaActual > this.totalPaginas) {
        this.cargandoScroll = false; // Permite futuras cargas
        if (infiniteScroll) {
            infiniteScroll.complete(); // Asegura que el mensaje desaparezca
            infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled` en lugar de `enable(false)`
        }
        return;
    }

    this.servicio.buscarProductosPaginadoInfinito(companiasId, this.paginaActual, this.cantidadPorPagina, this.search, true)
        .subscribe((data: any) => {
            const productoPagina = !NUBE_AWS ? data : JSON.parse(data['_body']).data;

            if (productoPagina.length > 0) {
                let listaProductosCopia = [...this.listaProductos, ...productoPagina];
                this.listaProductos = [];
                this.listaProductos = listaProductosCopia.reduce((acc, productos) => acc.concat(productos), []);

                this.paginaActual++; // Solo incrementa después de recibir la respuesta
            } else {
                if (infiniteScroll) {
                    infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                }
            }

            this.cd.detectChanges();
            this.cargandoScroll = false;

            if (infiniteScroll) {
                setTimeout(() => {
                    if (infiniteScroll) {
                        infiniteScroll.complete();
                        infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                        this.cd.detectChanges();
                    }
                }, 300);
            }
        }, error => {
            console.log(error);
            this.cargandoScroll = false;

            if (infiniteScroll) {
                console.log("Ejecutando infiniteScroll.complete();");
                infiniteScroll.complete(); // Oculta el mensaje en caso de error
                infiniteScroll.disabled = true; // 🔹 Cambiado a `disabled`
                this.cd.detectChanges();
            }
        });
}



  onSearch(valor: string) {
    this.search = valor.trim(); // Actualiza el valor de búsqueda sin espacios extras
    this.paginaActual = 1; // Reinicia la paginación
    this.listaProductos = []; // Limpia la lista para cargar los nuevos resultados
    this.cargarProductosPaginados(); // Llama al método de carga
  }
  selectInputContentProductos(event: any) {
    const inputElement = event.target;

    if (this.permitirSeleccion && inputElement && inputElement.value) {
      inputElement.setSelectionRange(0, inputElement.value.length);
    }
  }


searchCodigoBarraPaginador(cantidadafn:any,i:any){

  setTimeout(async () => {

    if (typeof cantidadafn['value'] === 'string' && cantidadafn['value'] !== "") {
      const numericValue = Number(cantidadafn['value']);
      if (!isNaN(numericValue)) {
        // El valor es un número, se puede manejar normalmente
        this.codigoBarra = cantidadafn['value'];
      } else {
        // El valor es una cadena alfanumérica
        this.codigoBarra = cantidadafn['value'];
      }
    } else {
      // El valor no es una cadena o está vacío
      cantidadafn['value'] = "";
      return;
    }

    if (this.codigoBarra === "") {
      this.showBuscarProducto = true;
      return false;
    }

    const tiempoActual = new Date().getTime();
    if (this.codigoBarra === this.ultimoCodigoBarra && (tiempoActual - this.ultimoTiempoEscaneo) < 500) {
      console.log("Código escaneado muy rápido, ignorando duplicado:", this.codigoBarra);
      return;
    }
    // Guardar el último código escaneado y el tiempo
    this.ultimoCodigoBarra = this.codigoBarra;
    this.ultimoTiempoEscaneo = tiempoActual;
    this.codigoBarra = cantidadafn['value'];
    this.paginaActual = 1; // Reinicia la paginación
    this.listaProductos = []; // Limpia la lista para cargar los nuevos resultados
    this.search = this.codigoBarra
    this.cargarProductosPaginados();
 }, 1000);
}

toggleTipoProductoAsignarValorReal(tipo:string) {
  this.tipoproducto = tipo
  if(this.tipoproducto === 'P') {
    this.tipoproductoTexto = 'Producto'
  } else {
    this.tipoproductoTexto = 'Producto elaborado'
  }
}

toggleTipoImpuestoAsignarValorReal(tipo:string) {
  this.tipoImpuesto = tipo
  if(this.tipoImpuesto === 'I') {
    this.tipoImpuestoTexto = 'Impoconsumo'
  } else {
    this.tipoImpuestoTexto = 'Iva'
  }
}


}



// WEBPACK FOOTER //
// ./src/components/productos-rapidos/productos-rapidos.ts